<template>
  <page-header-wrapper>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="vertical">
        <standard-form-row block>
          <div class="ant-pro-page-header-search">
            <a-input-search
              size="large"
              style="width: 80%; max-width: 522px;"
              v-model="params.where.exam_realname"
              placeholder="请输入要搜索的姓名"
              enter-button
              allow-clear
              @search="getLists()"
            />
            <a-button type="link" @click="() => (this.search = !this.search)">
              高级筛选
              <a-icon :type="search ? 'up' : 'down'" />
            </a-button>
          </div>
        </standard-form-row>
        <template v-if="search">
          <a-row :gutter="48">
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="手机号">
                <a-input
                  v-model="params.where.exam_mobile"
                  placeholder="请输入要搜索的手机号"
                  allow-clear
                  @pressEnter="getLists()"
                />
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="身份证号">
                <a-input
                  v-model="params.where.exam_idcard"
                  placeholder="请输入要搜索的身份证号"
                  allow-clear
                  @pressEnter="getLists()"
                />
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="证书">
                <a-spin :spinning="crtsLoad">
                  <a-select
                    placeholder="请选择要筛选的证书"
                    mode="multiple"
                    optionFilterProp="children"
                    name="member"
                    allow-clear
                    v-model="params.where.crt_id"
                    @change="getLists()"
                  >
                    <a-select-option
                      v-for="item in crtsList"
                      :key="item.id"
                      :disabled="item.disabled"
                    >
                      {{ item.title }}
                    </a-select-option>
                  </a-select>
                </a-spin>
              </a-form-item>
            </a-col>
            <a-col :lg="8" :md="12" :sm="24">
              <a-form-item label="日期">
                <a-range-picker
                  :ranges="{
                    最近七天: [moment().subtract('days', 6), moment()],
                    今天: [moment(), moment()],
                    本月: [moment().startOf('month'), moment()]
                  }"
                  :placeholder="['开始日期', '结束日期']"
                  @change="values => handleChangeDate(values)"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </a-form>
    </a-card>

    <a-card style="margin-top: 24px;" :bordered="false" title="百度证书考试数据列表">
      <div slot="extra" class="d-flex change-state">
        <table-tool-bar-list
          :columns="settingColumns"
          :element="element"
          @change="toolBarChange"
          @reload="getLists()"
        />
        <export
          :columns="columns"
          :params="params"
          :url="apiList.getList"
          xlsxName="百度证书考试数据列表"
          v-action:export
          @click="getExportData"
        />
      </div>
      <a-table
        class="screenfull"
        :columns="columns"
        :data-source="list"
        :rowKey="record => record.id"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :size="size"
        :bordered="false"
        :scroll="scroll"
      >
        <template slot="operation" slot-scope="text, record">
          <div class="editable-row-operations">
            <a @click="() => handleDetailShow(record.id)"> 查看 </a>
          </div>
        </template>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { list, table, select } from '@/mixins' // 引入
import { StandardFormRow, TableToolBarList, Export } from '@/components'
import ModelDetail from './modules/ModelDetail'
const apiList = {
    getList: '/finances/baidu',
    crtsList: '/certificates/select'
}

const columns = [
    {
        title: 'ID',
        dataIndex: 'id',
        sorter: true
    },
    {
        title: '姓名',
        dataIndex: 'exam_realname'
    },
    {
        title: '考试场次ID',
        align: 'center',
        sorter: true,
        dataIndex: 'session_id'
    },
    {
        title: '考试链接',
        dataIndex: 'session_url'
    },
    {
        title: '准考证号',
        dataIndex: 'exam_no',
        sorter: true
    },
    {
        title: '身份证号',
        dataIndex: 'exam_idcard',
        sorter: true
    },
    {
        title: '手机号',
        dataIndex: 'exam_mobile',
        sorter: true
    },

    {
        title: '性别',
        dataIndex: 'exam_sex'
    },
    {
        title: '邮箱',
        dataIndex: 'exam_email'
    },
    {
        title: '学历',
        dataIndex: 'exam_education'
    },
    {
        title: '身份',
        dataIndex: 'exam_role'
    },
    {
        title: '在读学校/在职公司',
        dataIndex: 'exam_position'
    },
    {
        title: '考试方向',
        dataIndex: 'exam_direction'
    },
    {
        title: '考试时间',
        dataIndex: 'exam_time'
    },
    {
        title: '考试状态',
        dataIndex: 'exam_state'
    },
    {
        title: '是否通过',
        dataIndex: 'exam_passed'
    },
    {
        title: '考试分数',
        dataIndex: 'exam_score'
    },
    {
        title: '证书获得时间',
        dataIndex: 'exam_crt_gettime'
    },
    {
        title: '证书编号',
        dataIndex: 'exam_crt_no'
    },
    {
        title: '证书有效期截止时间',
        dataIndex: 'exam_crt_limittime'
    },
    {
        title: '是否设置考试结果',
        dataIndex: 'exam_setres'
    },
    {
        title: '证书路径',
        dataIndex: 'exam_crtpath'
    },
    {
        title: '创建时间',
        dataIndex: 'created_at',
        sorter: true
    },
    {
        title: '更新时间',
        dataIndex: 'updated_at',
        sorter: true
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: 100,
        align: 'center',
        fixed: 'right',
        scopedSlots: { customRender: 'operation' }
    }
]
export default {
    name: 'LmsList',
    mixins: [list, table, select], // 使用mixins
    components: {
        StandardFormRow,
        ModelDetail,
        TableToolBarList,
        Export
    },
    data () {
        return {
            apiList,
            scroll: {
                x: 3800
            },
            columns,
            settingColumns: JSON.parse(JSON.stringify(columns)), // 深度复制表头
            crtsLoad: false, // 证书下拉加载
            crtsList: null // 证书下拉列表
        }
    },
    mounted () {
        this.getLists() // 获取列表
        this.getSelectLists({
            url: apiList.crtsList,
            type: 'crtsList',
            load: 'crtsLoad'
        }) // 获取证书列表
    },
    methods: {
        /**
         * 弹窗展示
         * aid广告id
         * @params
         *
         * ModelDetail
         */
        handleDetailShow (id) {
            this.$dialog(
                ModelDetail,
                // component props
                {
                    id,
                    on: {
                        ok () {},
                        cancel () {},
                        close () {}
                    }
                },
                // modal props
                {
                    title: '百度证书考试数据详情',
                    width: 700,
                    centered: true,
                    maskClosable: false
                }
            )
        },
        /**
         * 获取打印数据
         * @jdy
         *newColumns,data
         * @2020-11-30
         */
        getExportData (columns, data) {
            this.outputXlsxFile(
                columns,
                data,
                '**百度证书考试数据列表' + this.moment(new Date()).format('YYYYMMDDHHmmss')
            )
        }

    }
}
</script>
